import { createSlice  } from "@reduxjs/toolkit";
import { Settings } from "../utils/types";

const initialState: Settings = {
  add_to_cart_button_caption: "Add to cart",
  arrow_color_theme: "light",
  arrow_custom_box_color: "#000000",
  arrow_custom_color: "#d3d3d3",
  arrow_graphics_type: "type_1",
  arrow_size: "standard",
  arrow_size_custom: 48,
  background_color: "#000000", // check this value
  close_button_color_theme: "dark_btn", 
  close_button_custom_box_color: "#000000",
  close_button_custom_color: "#d3d3d3",
  close_button_position: "side",
  close_button_size: "standard",
  close_button_type: "btn_type_1",
  customer_photo_item_label: "Add Your Photo",
  customer_photo_item_position: null, // number, default value null
  customer_photo_upload_body: "We would love to see it in action",
  customer_photo_upload_button_selector: "",
  customer_photo_upload_complete_body: "Thank you for your awesome photo! You will see it on the site once it’s approved",
  customer_photo_upload_complete_close_label: "Close",
  customer_photo_upload_drop_files_label: "Drag & Drop photos here",
  customer_photo_upload_form_body_placeholder: "Say something about your image",
  customer_photo_upload_form_email_placeholder: "E-mail",
  customer_photo_upload_form_legal_message: "",
  customer_photo_upload_form_name_placeholder: "Nickname",
  customer_photo_upload_form_send_label: "Send",
  customer_photo_upload_form_uploading: "Uploading...",
  customer_photo_upload_title: "Show It off",
  customer_widget_cover: null,
  desktop_arrow_position: "middle",
  direct_add_to_cart: true,
  display_type: "grid", // TODO check default value
  font_family: "Source Sans Pro",
  gallery_highlight: false,
  gallery_highlight_every: 0,
  gallery_highlight_every_start: 0,
  gallery_mobile_photos_per_row: 2,
  gallery_photos_count: 0,
  gallery_photos_per_row: 4,
  header_show_average_rating: true,
  header_show_breakdown: true, // TODO check default value
  header_show_sort: true,
  header_type: "header-1",
  hide_branding: false,
  hide_social_links: false,
  highlight_hotspots_layout: "hotspot-tall", // TODO BE, move hotspots layout to hotspots
  highlight_layout: "slider",
  highlight_products_layout: "layout-1",
  hotspots: {
    enabled: false,
    background_color: "#000000",
    show_numbers: false,
    text_color: "#ffffff" 
  },
  item_reveal_content: "",
  item_animation_duration: 1,
  item_animation_type: "hover-animation-1",
  item_hover_background_opacity: 80,
  item_hover_border_color: "#C1ACAC",
  item_hover_color_from: "#000000", // check default value
  item_hover_color_to: "#000000", // check default value
  item_hover_disabled: false,
  item_hover_icon: false,
  item_label_color: "#FFFFFF",
  item_label_font_size: 15,
  item_label_font_style: "Normal",
  item_label_text: "SHOP THIS LOOK",
  item_mobile_padding: 0,
  item_open_link: false,
  item_padding: 1,
  item_style: "standard",
  item_without_product_label_text: "SEE MORE",
  load_more_border_width: 4,
  load_more_button_color: "#000000",
  load_more_button_style: "btn_style_1",
  load_more_font_size: 14,
  load_more_font_style: "bold",
  load_more_padding: 6,
  load_more_text: "MORE",
  mobile_arrow_color_theme: "mob_light",
  mobile_arrow_custom_box_color: "#000000",
  mobile_arrow_custom_color: "#d3d3d3", 
  mobile_arrow_graphics_type: "mob_type_1",
  mobile_arrow_position: "mob_top",
  money_format: "{{amount}}",
  multiple_filter_enabled: false,
  padding: 0,
  pagination: "button", // TODO strange name of settings
  popup_animation: true,
  popup_background_color: "#000000",
  popup_background_opacity: 80,
  popup_buy_button_background_color: "#444444",
  popup_buy_button_background_hover_color: "#000000",
  popup_buy_button_text_color: "#FFFFFF",
  popup_buy_button_text_hover_color: "#000000",
  popup_custom_link_label: "Visit",
  popup_disable_modal: false,
  popup_image_size: "responsive",
  popup_products_button_caption: "Buy Now",
  popup_products_title: "SHOP THIS LOOK",
  popup_products_title_disabled: false,
  popup_buy_button_style: "buy_btn_style_1",
  popup_products_view_type: "grid_view",
  price_label_caption: "Price",
  primary_color: "#222222", // TODO check this value
  secondary_color: "#BFBFBF",
  select_label_caption: "Select",
  show_header: false,
  show_price: true,
  show_price_in_popup: true,
  show_review: true,
  slideshow_autoplay: 0, // // TODO check this value
  slideshow_arrows_desktop_align: "start", // (top, bottom) start, end, center, stretch / (middle) inside, outside
  slideshow_arrows_mobile_align: "start", // (top, bottom) start, end, center, stretch / (middle) inside, outside
  slideshow_arrows_desktop_position: "top", // bottom, middle, top, none
  slideshow_arrows_mobile_position: "top", // bottom, middle, top, none
  slideshow_scrollbar_desktop_align: "start", // (top, bottom) start, end, center, stretch / (middle) inside, outside
  slideshow_scrollbar_mobile_align: "start", // (top, bottom) start, end, center, stretch / (middle) inside, outside
  slideshow_scrollbar_desktop_position: "top", // bottom, middle, top
  slideshow_scrollbar_mobile_position: "top", // bottom, middle, top
  slideshow_load_more: true, // TODO check this value
  slideshow_video_auto_play: false, 
  slideshow_mobile_photos_per_row: 2, // TODO check this value
  slideshow_photos_per_row: 4, // TODO check this value
  slideshow_crop_mode: false, // slider crop mode, if user select 4 items and 5% space -> display ~ 3.8 slide
  slideshow_style: "regular",
  slideshow_desktop_pagination_style: "none", // none, dots, animated-dots, line
  slideshow_mobile_pagination_style: "dots", // none, dots, animated-dots, line
  star_color: "#FCD02C", // TODO BE (rename vars to filter_) check this value
  tags_color: "", // TODO BE (rename vars to filter_), check default value
  tags_font_size: 12, // TODO BE (rename vars to filter_), check default value
  tags_font_weight: "", // TODO BE (rename vars to filter_)
  tags_padding: 0, // TODO BE (rename vars to filter_), check default value
  tags_reset_button_text: "" // TODO BE (rename vars to filter_), check default value 
};

// converted properies based on BE settings
const settingsWithConvertedProperties = (settings: Settings): Settings => {
  settings._arrowsDesktopType = `arrows-${settings.arrow_graphics_type.toString().replace("_", "-")}`;
  settings._arrowsDesktopSizeType = settings.arrow_size.toString().replace("_arrow", "");
  settings._arrowsDesktopPosition = settings.desktop_arrow_position.toString().replace("sidebar_", "");
  settings._arrowsMobileColorTheme = settings.mobile_arrow_color_theme.toString().replace("mob_", "");
  settings._arrowsMobilePosition = settings.mobile_arrow_position.toString().replace("mob_", "");
  settings._arrowsMobileType = settings.mobile_arrow_graphics_type.toString().replace("mob_", "arrows-").replace("_", "-");
  settings._buyButtonStyle = settings.popup_buy_button_style.replace("buy_btn_", "").replace("_", "-");
  settings._closeButtonType = settings.close_button_type.toString().split("_").join("-");
  settings._closeButtonСolorTheme = `close-button-color-theme-${settings.close_button_color_theme.toString().replace("_btn", "")}`;
  return settings;
};

const slice = createSlice({
  name: "settings",
  initialState: settingsWithConvertedProperties(initialState),
  reducers: {
    setSettings: (settings, action) => {
      settings = settingsWithConvertedProperties(action.payload);
      return settings;
    },
  }
});

export const { setSettings } = slice.actions;
export default slice.reducer;
